import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import ApiService from "../../../functions/apiService";

export default function AddStations() {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalMode, setModalMode] = useState("employee");

  let columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) =>
        params.row.EA_Rank ?? "" + " " + params.row.fullName,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "EHd_Seniority",
      headerName: "Seniority",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Auth_Flags",
      headerName: "Auth Flags",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  let columns2 = [
    {
      field: "Employee",
      headerName: "Employee",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Shift_Date",
      headerName: "Shift Date",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  const onSubmit = () => {
    console.log("body");
  };
  const onSubmit1 = () => {
    setLoading(true);
    ApiService.post("/postUpdateSeniority", [])
      .then((data) => {
        setModalMode("employee");
        setLoading(false);
        console.log("data", data);
        setModalData(data.data);
        setOpen(true);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit2 = () => {
    setModalMode("employee");
    setLoading(true);
    ApiService.post("/createAuthorityRecords", [])
      .then((data) => {
        setLoading(false);
        console.log("data", data.data);
        setModalData(Object.values(data.data));
        setOpen(true);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit3 = () => {
    setLoading(true);
    ApiService.post("/renumberSelectOptions", [])
      .then((data) => {
        setLoading(false);
        console.log("data", data);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit4 = () => {
    setModalMode("shifts");
    setLoading(true);
    ApiService.post("/AddPayrollHours", [])
      .then((data) => {
        setLoading(false);
        console.log("data", data.data);
        setModalData(Object.values(data.data));
        setOpen(true);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit5 = () => {
    setLoading(true);
    ApiService.post("/updateOvertimeList", [])
      .then((data) => {
        setLoading(false);
        console.log("data", data);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit6 = () => {
    setLoading(true);
    ApiService.post("/acceptHours", [])
      .then((data) => {
        setLoading(false);
        console.log("data", data);
        if (data.message) {
          enqueueSnackbar(data.message, { variant: "success" });
        } else {
          enqueueSnackbar("success", { variant: "success" });
        }
      })
      .catch(({ data }) => {
        setLoading(false);
        enqueueSnackbar("Error", { variant: "error" });
      });
  };
  let closeModal = () => {
    setOpen(false);
  };
  return (
    <>
      {/* <Typography fontWeight='500' fontSize="20px">Add Stations</Typography>
        <div className="col-12 my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit} color='primary'>Add Stations</ButtonTheme>
        </div>
        <hr /> */}

      <Typography fontWeight="700" fontSize="16px">
        Misc Update
      </Typography>
      <div className="col-12 my-3">
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit1}
          color="primary"
          className="mx-2"
        >
          Update Seniority
        </ButtonTheme>
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit2}
          color="primary"
          className="mx-2"
        >
          Create Authority Records
        </ButtonTheme>
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit3}
          color="primary"
          className="mx-2"
        >
          Renumber Select Options
        </ButtonTheme>
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit4}
          color="primary"
          className="mx-2"
        >
          Add Payroll Hours
        </ButtonTheme>
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit5}
          color="primary"
          className="mx-2"
        >
          Update Overtime List
        </ButtonTheme>
      </div>
      <Typography fontWeight="700" fontSize="16px">
        Misc Update 2 !!
      </Typography>
      <div className="col-12 my-3">
        <ButtonTheme
          disabled={loading}
          onClick={onSubmit6}
          color="primary"
          className="mx-2"
        >
          Accept Hours
        </ButtonTheme>
        {/* <ButtonTheme disabled={loading} onClick={onSubmit} color='primary' className='mx-2'>Random Last Names</ButtonTheme> */}
      </div>
      <ConfModal Title="Employee" open={open} closeModal={closeModal}>
        {modalData && modalData && modalData.length > 0 && (
          <div>
            <MyTable
              rows={modalData}
              columns={modalMode == "employee" ? columns : columns2}
              useTopFilter={false}
              checkboxSelection={false}
              hideFooter={true}
            />
          </div>
        )}
      </ConfModal>
    </>
  );
}
